export const LOCALES = {
  en: "en",
  ar: "ar",
  es: "es",
};
